// Task coordinator (Phase 5 module) — arbitrates the live heartbeat vs. an active screener scan so
// the heaviest work (full pipeline refresh) yields to a running scan. Depends on shared `state` + Logger.
import { state } from './state.js';
import { Logger } from './logger.js';

export const TaskCoordinator = {
    // True while a screener scan is actively enriching (not paused).
    // (state.* props are always defined — state.js initializes before this module and before any
    // runtime call to screenerBusy() — so the old `typeof … !== 'undefined'` guards are unnecessary.)
    screenerBusy() {
        return state.screenerRunning && !state.screenerPaused;
    },
    // Should the live heartbeat run its FULL (pipeline) refresh right now?
    // No while a scan is busy — full refresh is the heaviest task and lowest urgency
    // relative to finishing the scan; it gets deferred until the scan yields.
    allowFullRefresh() { return !this.screenerBusy(); },
    // Lightweight snapshot is cheap; allow it during a scan but at a slower cadence
    // so we add minimal load. Returns the snapshot interval (seconds) to use now.
    snapshotInterval(baseSec) {
        return this.screenerBusy() ? Math.max(baseSec, baseSec * 2) : baseSec;
    },
    // Let callers note why a task was skipped (surfaces in the debug log).
    note(msg, ctx) { if (typeof Logger !== 'undefined') Logger.debug('[Coordinator] ' + msg, ctx || {}); }
};
if (typeof window !== 'undefined') window.TaskCoordinator = TaskCoordinator;
